import { Loader2 } from 'lucide-react';
import type { ComponentProps } from 'react';

import { cn } from '@/shared/lib/cn';

/**
 * Loading indicator. Decorative by default (the surrounding UI announces the state);
 * pass `label` when the spinner alone conveys it — it then becomes a `status` with that name.
 */
export function Spinner({ className, label, ...props }: ComponentProps<'svg'> & { label?: string }) {
  const a11y = label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true };
  return (
    <Loader2 {...a11y} className={cn('size-4 animate-spin text-muted-foreground', className)} {...props} />
  );
}
